var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PersonEWListWeb"},[_c('v-data-table',{attrs:{"dense":"","disable-sort":false,"headers":_vm.headers,"hide-default-footer":!_vm.pagination,"disable-pagination":!_vm.pagination,"footer-props":{
      'items-per-page-options': [5, 10, 15, 50, 100, -1],
      'items-per-page-text': _vm.$t('rowsPerPage'),
      'show-first-last-page': true,
    },"items":_vm.list,"item-class":_vm.row_classes,"item-key":"MessageId"},on:{"click:row":_vm.handleClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }